<template>
  <div class="common-layout" style="height: 100%">
    <el-container style="height: 100%">
      <el-aside width="200px" style="height: 100%; overflow: hidden !important;">
        <el-image :src="sourceLogo" :fit="cover" style="height: 6%;display: flex;justify-content: center;" />
        <el-menu
            active-text-color="#ffd04b"
            background-color="#545c64"
            class="el-menu-vertical-demo"
            text-color="#fff"
            :default-active="activeMenu"
            @select="handleMenuSelect"
            style="height: 94%"
        >
          <el-menu-item index="Dashboard" v-if="isAllowed('/admin/dashboard')">
            <el-icon><House /></el-icon>
            <span>Trang chủ</span>
          </el-menu-item>
          <el-menu-item index="Department" v-if="isAllowed('/admin/department')">
            <el-icon><Avatar /></el-icon>
            <span>Phòng ban</span></el-menu-item>
          <el-menu-item index="Staff" v-if="isAllowed('/admin/staff')">
            <el-icon><User /></el-icon>
            <span>Nhân viên</span></el-menu-item>
        </el-menu>
      </el-aside>
      <el-container>
        <el-header style="text-align: right;height: 6%">
          <div class="toolbar" style="margin: auto">
            <el-dropdown style="font-size: 24px;padding: 10px;">
              <el-icon>
                <User />
              </el-icon>
              <template #dropdown>
                <el-dropdown-menu>
                  <el-dropdown-item @click="doLogout()">Logout</el-dropdown-item>
                </el-dropdown-menu>
              </template>
            </el-dropdown>
          </div>
        </el-header>
        <el-main style="background: #f2f3f5 !important; height: 94%">
          <router-view></router-view>
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>

<script setup>
import {onMounted, ref} from 'vue';
import {useRoute, useRouter} from 'vue-router';
import {Avatar, House, User} from "@element-plus/icons-vue";
import {logout} from "@/api/auth";

const route = useRoute();
const router = useRouter();
const activeMenu = ref(route.name || 'Dashboard');
let allowedPaths = ref([])
const sourceLogo = ref("https://eparking.vn/wp-content/uploads/2021/07/eparking-3.png")

const handleMenuSelect = (index) => {
  activeMenu.value = index;
  switch (index) {
    case 'Dashboard':
      router.push('/admin/dashboard');
      break;
    case 'Department':
      router.push('/admin/department');
      break;
    case 'Staff':
      router.push('/admin/staff');
      break;
    default:
      router.push('/admin/dashboard');
  }
};

const isAllowed = (path) => {
  return allowedPaths.value.includes(path);
};

const doLogout = async () => {
  await logout()
  localStorage.removeItem('token')
  localStorage.removeItem('permissions')
  router.push('/login')
}

onMounted(() => {
  allowedPaths.value = JSON.parse(localStorage.getItem('allowedPaths') || '[]');
})
</script>

<style scoped>

.el-menu-vertical-demo {
  width: 200px;
  height: 100%;
}

.content {
  flex: 1;
  padding: 20px;
}

.el-header {
  position: relative;
}
</style>
